<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-progress-bar md-mode="indeterminate" v-if="isLoading"/>
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Ports List</h4>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goToAdd" class="md-primary md-dense">
                            Add Port
                        </md-button>
                    </div>
                    <md-table
                            :value="table"
                            :md-sort.sync="sortation.field"
                            :md-sort-order.sync="sortation.order"
                            :md-sort-fn="customSort"
                            class="paginated-table table-striped table-hover"
                    >
                        <md-table-toolbar>
                            <md-field>
                                <label>Per page</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option
                                            v-for="item in pagination.perPageOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                    >
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field>
                                <md-input
                                        v-model="query"
                                        type="search"
                                        class="mb-3"
                                        clearable
                                        style="width: 200px"
                                        placeholder="Search ..."
                                >
                                </md-input>
                            </md-field>
                        </md-table-toolbar>

                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Name" md-sort-by="name">
                              {{item.name}}
                            </md-table-cell>

                            <md-table-cell md-label="Station" >
                              {{item.station?item.station.name : ''}}
                            </md-table-cell>
                            <md-table-cell md-label="Code" md-sort-by="code">
                              {{item.code}}
                            </md-table-cell>
                            <md-table-cell md-label="Short Name" md-sort-by="short_name">
                              {{item.short_name}}
                            </md-table-cell>
                            <md-table-cell md-label="Workplaces" md-sort-by="workplaces_count">
                              <span class="clickable-count" @click="showWorkplaces(item)">
                                {{ item.workplaces?item.workplaces.length:0 }}
                              </span>
                            </md-table-cell>
                            <md-table-cell md-label="Labourers" md-sort-by="labourers_count">
                              <span class="clickable-count" @click="showLabourers(item)">
                                {{ item.labourers?item.labourers.length:0 }}
                              </span>
                            </md-table-cell>
                            <md-table-cell md-label="Created At" md-sort-by="created_at">{{item.created_at}}</md-table-cell>
                            <md-table-cell md-label="Actions">
                                <md-button
                                        class="md-icon-button md-raised md-round md-info"
                                        @click="getToView(item.id)"
                                        style="margin: 0.2rem"
                                >
                                    <md-icon>search</md-icon>
                                </md-button>
                                <md-button
                                        class="md-icon-button md-raised md-round md-info"
                                        @click="goToEdit(item.id)"
                                        style="margin: 0.2rem"
                                >
                                    <md-icon>edit</md-icon>
                                </md-button>
                                <md-button
                                        class="md-icon-button md-raised md-round md-danger"
                                        @click="destroy(item.id)"
                                        style="margin: 0.2rem"
                                >
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>

                    <div class="footer-table md-table">
                        <table>
                            <tfoot>
                            <tr>
                                <th
                                        v-for="item in footerTable"
                                        :key="item.name"
                                        class="md-table-head"
                                >
                                    <div class="md-table-head-container md-ripple md-disabled">
                                        <div class="md-table-head-label">
                                            {{ item }}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </md-card-content>

                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                        </p>
                    </div>
                    <pagination
                            class="pagination-no-border pagination-success"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                    />
                </md-card-actions>
            </md-card>
          <md-dialog :md-active.sync="dialog.active">
            <md-dialog-title>{{ dialog.title }}</md-dialog-title>

            <md-dialog-content>
              <md-list v-if="dialog.items.length">
                <md-list-item v-for="(item, index) in dialog.items" :key="index">
                  {{ item.name }}
                </md-list-item>
              </md-list>
              <p v-else class="text-center">No data available.</p>
            </md-dialog-content>

            <md-dialog-actions>
              <md-button class="md-primary" @click="dialog.active = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert2';

export default {
    components: {
        pagination: Pagination,
    },

    data: () => ({
        isLoading: false,
        table: [],
        footerTable: [
            'Name',
            'Code',
            'Short Name',
            'Created At',
            'Actions'],

        query: null,

        sortation: {
            field: 'created_at',
            order: 'asc',
        },

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
        },

        total: 0,
        dialog: {
            active: false,
            title: '',
            items: []
        }
    }),

    computed: {
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
    },

    watch: {
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        sortation: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
    },

    methods: {
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

        async getList () {
            this.isLoading = true;
            let params = {
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                    ...(this.query ? { name: this.query } : {}),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
                include:'station'
            };

            try {
                await this.$store.dispatch('ports/list', params);
                this.table = this.$store.getters['ports/list'];
                this.total = this.$store.getters['ports/listTotal'];
            } catch (e) {
                this.notifyException(e);
            } finally {
                this.isLoading = false;
            }
        },

        async destroy (station) {
            const confirmation = await Swal.fire({
                title: 'Delete this station?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                this.isLoading = true;
                try {
                    await this.$store.dispatch('ports/destroy', station);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Ports deleted successfully.'
                    );
                    await this.getList();
                } catch (e) {
                    if (e.response.data.errors[0]) {
                        await this.$store.dispatch(
                            'alerts/error',
                            e.response.data.errors[0].title
                        );
                    } else {
                        this.notifyException(e);
                    }
                } finally {
                    this.isLoading = false;
                }
            }
        },

        goToAdd () {
            this.$router.push({ name: 'Add Port' });
        },

        goToEdit (id) {
            this.$router.push({ name: 'Edit Port', params: { id } });
        },

        getToView (id) {
            this.$router.push({ name: 'view Port', params: { id } });
        },

        customSort () {
            return false;
        },
        async showWorkplaces (port) {
            try {
                this.dialog.title = `Activities for ${port.name}`;
                this.dialog.items = port.workplaces;
                this.dialog.active = true;
            } catch (e) {
                this.notifyException(e);
            }
        },

        async showLabourers (port) {
            try {
                this.dialog.title = `Labourers for ${port.name}`;
                this.dialog.items = port.labourers;
                this.dialog.active = true;
            } catch (e) {
                this.notifyException(e);
            }
        }
    },
};
</script>
